import api from "../../../utilities/interseptor";
const key = process.env.REACT_APP_CLAVE_INCRIPTACION;
const apiUrl = process.env.REACT_APP_API


export class VistaProgramadosIntegracion {
    static getVistaProgramados = (data, setVistaProgramados, setTotales) => {
        api.get(`${apiUrl}/monitor/vista_programados?fecha_inicio=${data.fecha_inicio}&fecha_fin=${data.fecha_fin}&proveedor=${data.proveedor}&cliente=${data.cliente}&ruta=${data.ruta}`).then((res) => {
            var totales = []

            res.data.map((item, key) => {
                let totalServicios = 0
                let total_ruta = 0
                let total_no_facturar = 0
                let total_facturar = 0
                let total_medios = 0
                let total_sencillos = 0
                let dinero_total_medios = 0
                let dinero_total_sencillos = 0



                item.map((object, index) => {


                    // convertir de arreglos a objetos
                    totalServicios = totalServicios + object.SERVICIOS
                    total_ruta = total_ruta + object.TOTAL_PRECIO_CLIENTE
                    total_medios = total_medios + object.TIPO_MEDIOS
                    total_sencillos = total_sencillos + object.TIPO_SENCILLOS
                    dinero_total_medios = dinero_total_medios + object.TOTAL_TIPO_MEDIOS
                    dinero_total_sencillos = dinero_total_sencillos + object.TOTAL_TIPO_SENCILLOS

                })

                totales.push({
                     totalServicios: totalServicios,
                     total_ruta: total_ruta,
                     total_medios:total_medios,
                     total_sencillos:total_sencillos,
                     dinero_total_medios:dinero_total_medios,
                     dinero_total_sencillos:dinero_total_sencillos,
                    
                    })
            })


            setTotales(totales)
            setVistaProgramados(res.data)

        })
            .catch((error) => {
                console.log("error", error);

            })
    }
}